import { MdCalendarMonth, MdEventBusy } from "react-icons/md";
import { useSubscriptionGuard } from '../hooks/useSubscriptionGuard';

function getExpiringTitle(daysLeft) {
    if (daysLeft === 0) {
        return "Subscription expires today";
    }
    return `Subscription expires in ${daysLeft} ${daysLeft === 1 ? "day" : "days"}`;
}

// Warns before the selected hotel's subscription expires and explains the lock once it has.
export default function SubscriptionBanner({ hotelId }) {
    const { hotel, canEdit, daysLeft, isExpiringSoon, expiryText } = useSubscriptionGuard(hotelId);

    if (!hotel || daysLeft === null) {
        return null;
    }

    if (!canEdit) {
        return (
            <div role="alert" className="mx-2 mb-3 flex items-start gap-3 rounded-lg border border-red-300 bg-red-50 p-3 text-red-900 sm:p-4">
                <MdEventBusy className="mt-0.5 h-6 w-6 shrink-0 text-red-600" aria-hidden="true" />
                <div className="min-w-0">
                    <p className="font-bold">Subscription expired</p>
                    <p className="text-sm break-words">
                        Your subscription expired on {expiryText}. Please connect with InnPro to renew it and continue adding guests, checking in and making other changes.
                    </p>
                </div>
            </div>
        );
    }

    if (isExpiringSoon) {
        return (
            <div role="status" className="mx-2 mb-3 flex items-start gap-3 rounded-lg border border-orange-300 bg-orange-50 p-3 text-orange-900 sm:p-4">
                <MdCalendarMonth className="mt-0.5 h-6 w-6 shrink-0 text-orange-600" aria-hidden="true" />
                <div className="min-w-0">
                    <p className="font-bold">{getExpiringTitle(daysLeft)}</p>
                    <p className="text-sm break-words">
                        Your subscription is valid until {expiryText}. Please connect with InnPro to renew it and avoid interruption to check-ins and other changes.
                    </p>
                </div>
            </div>
        );
    }

    return null;
}
